// extracted by mini-css-extract-plugin
module.exports = {"PlaceholderRow":"styles_PlaceholderRow__39ukC"};